export const EndpointURL = 'https://readyapi.iqmetrix.net/';
export const AccountsApiEndpointURL = 'https://accounts.iqmetrix.net/';
export const UserManagerApiEndpointURL = 'https://usermanager.iqmetrix.net/v1/';
export const EntitiesApiEndpointURL = 'https://entitymanager.iqmetrix.net/v1/';
export const AmsAPIEndpointURL = 'https://ams.iqmetrix.net';
export const ReferenceEndpointURL = 'https://reference.iqmetrix.net/v1';



// WEBPACK FOOTER //
// ./src/constants.js